import { useEffect } from "react";
import {
  AdSystemT,
  MetaAdsWizardStepT,
  WizardStepT,
  useSetGoogleAdsWizardStepMutation,
  useSetMetaAdsWizardStepMutation,
} from "../../graphql/generated/graphql";

type UseSetWizardStepEffectT = {
  adSystem?: AdSystemT;
  wizardStep: WizardStepT | MetaAdsWizardStepT;
};
export const useSetWizardStepEffect = ({ adSystem = AdSystemT.GoogleAdsT, wizardStep }: UseSetWizardStepEffectT) => {
  const [setGoogleAdsWizardStep] = useSetGoogleAdsWizardStepMutation();
  const [setMetaAdsWizardStep] = useSetMetaAdsWizardStepMutation();

  useEffect(() => {
    if (adSystem === AdSystemT.GoogleAdsT) {
      setGoogleAdsWizardStep({ variables: { wizardStep: wizardStep as WizardStepT } });
    } else {
      setMetaAdsWizardStep({ variables: { wizardStep: wizardStep as MetaAdsWizardStepT } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adSystem, wizardStep]);

  return [];
};
